import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/api-client/auth.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  const uid: string | null = localStorage.getItem('uid');
  const accessToken: string | null = localStorage.getItem('access_token');

  if (!uid || !accessToken) {
    console.error(
      'No uid or access_token found. Redirecting back to LoginPage',
    );
    localStorage.clear();

    return router.parseUrl('login');
  }

  return authService.autoLogin(uid, accessToken).pipe(
    map(() => {
      return true;
    }),
    catchError((err) => {
      console.error(err);
      localStorage.clear();

      return of(router.parseUrl('login'));
    }),
  );
};
